import React, { useState, useEffect, useRef, useMemo } from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { Play, Pause } from 'lucide-react'; // ou toute autre icône
import { useTranslation } from 'react-i18next';
import '../css/PlaySlider.css';

// const DAY = 24 * 60 * 60 * 1000;

//const PlaySlider = ({ minDate, maxDate, results, value, onChange, speedMs = 2000 }) => {
const PlaySlider = ({ results, value, onChange, speedMs = 2000 }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const intervalRef = useRef(null);
  const { t } = useTranslation();
  
  // Liste triée des timestamps de scans
  const scanTimestamps = useMemo(() => {
    return results
      .map(r => new Date(r.createdAt).getTime())
      .sort((a, b) => a - b);
  }, [results]);

  // Trouve l'index courant à partir du timestamp actuel
  const currentIndex = useMemo(() => {
    return scanTimestamps.findIndex(ts => ts === value);
  }, [value, scanTimestamps]);

  // Stop quand on est au bout
  useEffect(() => {
    if (currentIndex === scanTimestamps.length - 1 && isPlaying) {
      setIsPlaying(false);
    }
  }, [currentIndex, scanTimestamps, isPlaying]);

  // on cap la valeur
  useEffect(() => {
    if (currentIndex < 0) onChange(0);
    if (currentIndex >= scanTimestamps.length) onChange(scanTimestamps.length-1);
  }, [currentIndex, scanTimestamps, onChange]);

  // Jouer automatiquement
    useEffect(() => {
    if (!isPlaying) {
      clearInterval(intervalRef.current);
      return;
    }
    intervalRef.current = setInterval(() => {
      onChange(prev => {
        const i = scanTimestamps.findIndex(ts => ts === prev);
        if (i >= 0 && i < scanTimestamps.length - 1) {
          return scanTimestamps[i + 1]; // passe au scan suivant
        } else {
          clearInterval(intervalRef.current);
          setIsPlaying(false);
          return prev;
        }
      });
    }, speedMs);


    return () => clearInterval(intervalRef.current);
  }, [isPlaying, scanTimestamps, onChange, speedMs]);

  const togglePlay = () => {
    if (currentIndex === scanTimestamps.length - 1) {
      onChange(scanTimestamps[0]);
    }
    setIsPlaying(p => !p);
  };


  const formatDate = (ts) => {
    const d = new Date(ts);
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yy = String(d.getFullYear()).slice(-2);   
    return `${dd}.${mm}.${yy}`;
  };
  const formatHour = (ts) => {
    const d = new Date(ts);
    const hh = String(d.getHours()).padStart(2, '0');
    const min = String(d.getMinutes()).padStart(2, '0');
    return `${hh}:${min}`;
  };

  const formatDateParts = (ts) => {
    const d = new Date(ts);
    return {
      date: formatDate(d),
      time: formatHour(d),
    };
  };

  if (scanTimestamps.length === 0) return null;

  const { date, time } = formatDateParts(value);

  const prevTimestamp = currentIndex > 0 ? scanTimestamps[currentIndex - 1] : null;
  const daysSincePrev = prevTimestamp
    ? Math.floor((value - prevTimestamp) / (1000*60*60*24))
    : 0;

  return (
    <div className="play-slider-container">
     
      <div className="play-controls">        
        <span className='slider-current-date'>
          {t("stats.pie.date", { date, time })}
          {currentIndex > 0 && ` ← ${t('deltafromlastscan', { count: daysSincePrev })}${daysSincePrev > 1 ?'s' : ''}`}
        </span>
      </div>

      <Slider
        min={0}
        max={scanTimestamps.length - 1}
        step={1}
        value={currentIndex >= 0 ? currentIndex : 0}
        onChange={(i) => onChange(scanTimestamps[i])}
        styles={{
          rail: { backgroundColor: '#ddd', height: 8 },
          track: { backgroundColor: '#4caf50', height: 8 },
          handle: {
            borderColor: '#4caf50',
            backgroundColor: '#fff',
            height: 20,
            width: 20,
            marginTop: -6,
          },
        }}
      />
      <button onClick={togglePlay} className="play-btn">
        {isPlaying ? <Pause size={20} /> : <Play size={20} />}
      </button>
    </div>
  );
};

export default PlaySlider;